import { defineAgent } from '../agent-definition';
import { TITLE_WORKSPACE_AGENT_TYPE } from '../agent-types';

export const TITLE_WORKSPACE_AGENT = defineAgent({
  agentType: TITLE_WORKSPACE_AGENT_TYPE,
  agentName: 'Insights Agent',
  // Already leads with the product name, so the header must not prepend it again.
  prefixNameWithProduct: false,
  triggerLabel: 'Ask about this workspace',
  // Sits among the workspace header's text buttons, so no border.
  triggerKind: 'ghost',
  inputPlaceholder: 'Ask about this workspace…',
  starters: [
    {
      title: 'What can you help with?',
      prompt:
        'What can you help with? Give me a short tour of what you can do, and list the tools I have access to through you.',
    },
    {
      title: 'What tools do you have access to?',
      prompt: 'List the tools you have access to, grouped by what they do.',
    },
    {
      title: 'Summarize this workspace',
      prompt:
        'Summarize this workspace: the latest calculation, the main entities with interest activity, and any notable documents.',
    },
    {
      title: 'What should I ask first?',
      prompt:
        "Inspect this workspace's latest calculation and suggest a specific question I should ask first — ideally something with a clear, interesting answer (e.g. an overconveyance, a high-activity entity, or a pivotal transaction). Then wait for me to ask it.",
    },
  ],
  // Workspace-specific wording for the `reason` codes this page's SSE endpoint
  // emits. Anything not listed falls back to the server's own message.
  errorCopy: {
    calculation_in_progress:
      'Workspace is recalculating — try again once it completes.',
    no_completed_calculation:
      'This workspace has no completed calculation yet. Run a calculation first.',
  },
});
